import * as React from 'react'
import { StyledGooleBlock, StyledGooleImage } from '$views/components/PoweredByGoogle/PoweredByGoogle.style'

const poweredByGoogle = require('$images/poweredByGoogle.png')

export const PoweredByGoogle: React.FC = () => {
  return (
    <StyledGooleBlock>
      <StyledGooleImage src={poweredByGoogle}></StyledGooleImage>
    </StyledGooleBlock>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/PoweredByGoogle/PoweredByGoogle.tsx